import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { Ask } from "@/features/ask"
import { NEW_CHAT_ACTION } from "@/components/Sidebar/navigation-config"

const policySearchSchema = z.object({
    [NEW_CHAT_ACTION]: z.coerce.string().optional(),
    chat: z.string().optional(),
})

export type PolicySearch = z.infer<typeof policySearchSchema>

export const Route = createFileRoute("/_authenticated/agent/policy/")({
    component: Ask,
    validateSearch: (search): PolicySearch => policySearchSchema.parse(search),
})
